import React from 'react';
import { Helmet } from 'react-helmet';

const SITE_NAME = 'Kanus Digital';
const SITE_URL = 'https://kanusdigital.com';
const DEFAULT_IMAGE = `${SITE_URL}/assets/imgs/brand/favicon-512.png`;
const DEFAULT_KEYWORDS = 'web tasarım, dijital ajans, dijital pazarlama, SEO, yazılım geliştirme, marka kimliği, kurumsal web sitesi, Kanus Digital';

function SeoHead({ title, description, keywords, path = '/', image }) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Web Tasarım & Dijital Pazarlama`;
  const fullUrl = `${SITE_URL}${path}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <html lang="tr" />
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords || DEFAULT_KEYWORDS} />
      <meta name="author" content={SITE_NAME} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}

export default SeoHead;
